export default __webpack_public_path__ + "static/media/Athletics Track, PKL-6.e3f43648.jpg";